import { Controller } from "@hotwired/stimulus"

// 배송방법 버튼 선택 컨트롤러
export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.updateButtons()
  }

  select(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.updateButtons()
  }

  updateButtons() {
    const currentValue = this.inputTarget.value
    this.buttonTargets.forEach(button => {
      const isSelected = button.dataset.value === currentValue
      if (isSelected) {
        button.classList.remove('btn-ghost', 'btn-outline')
        button.classList.add('btn-primary')
      } else {
        button.classList.remove('btn-primary')
        button.classList.add('btn-ghost', 'btn-outline')
      }
    })
  }
}
